import React, { useEffect, useState } from 'react';
import { View, Text } from 'react-native';
import InputDefault from "../../components/Form/InputDefault";
import RNPickerSelect from "react-native-picker-select";

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';
import { toast } from '../../utils/toast';
import api from '../../services/api';

import styles from './styles';

const BankAccountPix = () => {
    const [bank, setBank] = useState(0);
    const [typeAccount, setTypeAccount] = useState(0);
    const [agency, setAgency] = useState('');
    const [account, setAccount] = useState('');
    const [itemsBanks, setItemsBanks] = useState([]);
    const [accountType, setAccountType] = useState([]);

    useEffect(() => {
        getBanks();
        getAccountType();
    }, []);

    function getBanks() {
        api.get('/banks')
            .then((res) => {
                var banks = [];

                res.data.data.map(item => {
                    banks.push({
                        'label': item.bank,
                        'value': item.id
                    })
                })

                setItemsBanks(banks);
            })
            .catch((error) => {
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
            })
    }

    function getAccountType() {
        api.get('/bank-account-types')
            .then((res) => {
                var types = [];

                res.data.data.map(item => {
                    types.push({
                        'label': item.name,
                        'value': item.id
                    })
                })

                setAccountType(types);
            })
            .catch((error) => {
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
            })
    }

    return (
        <>
            <HeaderDefault title={"Agência e conta"} />

            <View style={styles.container}>
                <View style={styles.contentInput}>
                    <RNPickerSelect
                        onValueChange={(value) => setBank(value)}
                        placeholder={{
                            label: 'Selecione o banco',
                            value: 0,
                        }}
                        items={itemsBanks}
                        value={bank}
                        style={{
                            inputWeb: {
                                borderRadius: 4,
                                paddingHorizontal: 10,
                                height: 40,
                                marginVertical: 10,
                                color: '#222'
                            }
                        }} />

                    <RNPickerSelect
                        onValueChange={(value) => setTypeAccount(value)}
                        placeholder={{
                            label: 'Selecione o tipo de conta',
                            value: 0,
                        }}
                        items={accountType}
                        value={typeAccount}
                        style={{
                            inputWeb: {
                                borderRadius: 4,
                                paddingHorizontal: 10,
                                height: 40,
                                marginVertical: 10,
                                color: '#222'
                            }
                        }}
                    />

                    <InputDefault
                        value={agency}
                        onValueChange={(value) => setAgency(value)}
                        placeholder={"Agência"}
                        type={"numeric"}
                    />

                    <InputDefault
                        value={account}
                        onValueChange={(value) => setAccount(value)}
                        placeholder={"Número da Conta"}
                        type={"numeric"}
                    />
                </View>

                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor da transferência:</Text>
                    <Text>XXX,XXX.XXBRL</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Moeda:</Text>
                    <Text>GPX Token</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor do dia:</Text>
                    <Text>XX,XXX.XXGPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Recebedor:</Text>
                    <Text>Abelardo Bueno da Costa</Text>
                </View>
            </View>

            <Text style={styles.transferValueInfo}>*O valor desta transação é de R$3,90.</Text>
            <Button route={"ConfirmPassword"} text={"CONTINUAR"} titlePage={"Confirmar tranferência"} />
        </>
    );
}

export default BankAccountPix;